













































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppHeading, AppPicture, AppText } from '@/uikit';
import { Cancellation } from '../purchases/components';
import { State } from './types';

@Component({
  components: {
    AppText,
    AppPicture,
    AppHeading,
    Cancellation,
  },
})
export default class FeedbackCard extends Vue {
  @Prop({ type: Object, default: () => {} })
  readonly state!: State;

  @Prop({ type: String, default: '' })
  readonly partnerLogo!: string;

  @Prop({ type: String, default: '' })
  readonly partnerName!: string;

  @Prop({ type: String, default: '' })
  readonly vacancyName!: string;

  @Prop({ type: String, default: '' })
  readonly vacancyId!: string;

  @Prop({ type: String, default: '' })
  readonly id!: string;

  @Prop({ type: String, default: '' })
  readonly dateСreated!: string;

  @Prop({ type: Boolean, default: false })
  readonly userCanCancel!: boolean;

  get linkToVacancy() {
    return {
      name: 'vacancy',
      params: { id: this.vacancyId },
    };
  }

  cancelVacancy() {
    this.$emit('cancelVacancy', this.id);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/FeedbackCard/FeedbackCard.vue